module.exports = __webpack_public_path__ + "img/yxt_TC.69d09767.jpg";